/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appFocusTrap]'
})
export class FocusTrapDirective implements AfterViewInit {
    /**
     * Store the elements in the modal that can be focused.
     * @private
     */
    private focusableElements: any[];

    /**
     * Store the first element in the modal that can be focused.
     * @private
     */
    private firstElement: any;

    /**
     * Store the number of times the tab key has been pressed.
     * @private
     */
    private pressCount: number = 0;

    constructor(
        private elementRef: ElementRef
    ) {
    }

    public ngAfterViewInit(): void {
        this.focusableElements = this.elementRef.nativeElement.querySelectorAll('input:not([disabled]), button:not([disabled]), img');
        this.firstElement = this.focusableElements[0];
        this.firstElement.focus();
    }

    /**
     * Set mousedown target id.
     * @param event
     */
    @HostListener('document:keydown', ['$event'])
    public onKeyPress(event: KeyboardEvent): void {
        if (event.code === 'Tab' && event.shiftKey) {
            this.handleTabAndShift(event);
        }
        if (event.code === 'Tab' && !event.shiftKey) {
            this.handleTabOnly(event);
        }
    }

    /**
     * Handle tab key press.
     * @param event
     * @private
     */
    private handleTabOnly(event: KeyboardEvent): void {
        this.pressCount++;

        if (this.pressCount > (Array.from(this.focusableElements).length - 1)) {
            this.pressCount = 0;
        }

        this.focusableElements[this.pressCount].focus();
        event.preventDefault();
    }

    /**
     * Handle tab and shift key press.
     * @param event
     * @private
     */
    private handleTabAndShift(event: KeyboardEvent): void {
        this.pressCount--;
        if (this.pressCount < 0) {
            this.pressCount = this.focusableElements.length - 1;
        }
        this.focusableElements[this.pressCount].focus();
        event.preventDefault();
    }
}
